import React, { useEffect, useState } from "react";
import SocialMedia from '../component/SocialMedia/socialMedia';
import { FaReact } from 'react-icons/fa';
import highlightKeywords from '../data/highlightKeywords';
import Project from '../models/Project';
import FeaturedProjectModal from '../component/FeaturedProjectModal/FeaturedProjectModal';
import featuredProjects from '../data/featuredProjects';
import TechnicalSkills from '../models/TechnicalSkills';
import { Link } from 'react-router-dom';
import Footer from '../component/Footer/Footer';
/* ---------------- MAIN PAGE COMPONENT ---------------- */
function MainPage() {
  // Technical skills provided by the TechnicalSkills model
  const skillsData = new TechnicalSkills().toObject();

  const sections = [
    { label: "About Me", content: "Full-stack developer with 5 years of experience building modern, responsive web and mobile applications. Strong background in React, Angular, and Flutter, combined with hands-on experience designing scalable backend solutions using API Gateway, AWS Lambda, .NET, Next.js, and Spring Boot. Passionate about creating high-performance, user-focused applications with clean, maintainable code." },
    { label: "Projects", content: [
      'Spy Chess Game — Multiplayer strategy game with real-time moves',
      'MDC Monitoring — System monitoring dashboard with alerts',
      'Economy.com — Data-driven financial analysis site',
      'Portfolio Website — Personal showcases and case studies',
      'LinkTree Clone App — Compact social link landing page'
    ] },
    { label: "Technical Skills", content: "" },
    { label: "Experience", content: [
      "Software Engineer at Moody's Analytics (2020 — Present) — Built scalable React applications, improved performance, and led front-end initiatives.",
      'NASA Goddard Space Flight Center (Summer 2018) — Internship working on satellite data integrations and tooling.'
    ] },
    { label: "Contact", content: "Reach me via LinkedIn, GitHub, or Email below." },
  ];

  const socialLinks = [
    { label: "LinkedIn", url: "https://linkedin.com/" },
    { label: "GitHub", url: "https://github.com/" },
  ];

  // featured projects moved to src/data/featuredProjects.js
  // import available as `featuredProjects` above
  

  const [scrollY, setScrollY] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);

  // helper to highlight technical keywords (uses shared list)
  const escaped = highlightKeywords.map(k => k.replace(/[.*+?^${}()|[\\]\\]/g, '\\$&'));
  const keywordSet = new Set(highlightKeywords.map(k => k.toLowerCase()));
  function highlightTechnical(text) {
    if (!text) return text;
    const parts = text.split(new RegExp(`(${escaped.join('|')})`, 'gi'));
    return parts.map((part, i) => (
      keywordSet.has(String(part).toLowerCase()) ? (
        <span key={i} style={{ color: '#667eea', fontWeight: 700 }}>{part}</span>
      ) : part
    ));
  }

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div style={{ fontFamily: "'Roboto', sans-serif", margin: 0, padding: 0 }}>
      {/* Hero Section */}
      <section style={{ height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center', background: 'linear-gradient(135deg, #667eea, #764ba2)', color: '#fff', padding: '0 20px', opacity: scrollY < 50 ? 1 : 0.9, transition: 'opacity 0.8s ease-in-out' }}>
        <h1 style={{ fontSize: '60px', fontWeight: '700', marginBottom: '20px', transform: `translateY(${scrollY * 0.1}px)`, transition: 'transform 0.3s ease-out' }}>Marcus Nash</h1>
        <p style={{ fontSize: '22px', maxWidth: '600px', lineHeight: 1.4, transform: `translateY(${scrollY * 0.05}px)`, transition: 'transform 0.3s ease-out' }}>I'm a web developer building modern and responsive web experiences that delight users and drive business results.</p>
      </section>

      {/* Sections */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '100px 20px 60px 20px' }}>
       
        {/* Projects */}
        <section id="Projects" style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '32px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '24px' }}>Featured Projects</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '24px' }}>
            {featuredProjects.slice(0,3).map((p) => (
              <div key={p.id} role="button" tabIndex={0} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') setSelectedProject(p) }} onClick={() => setSelectedProject(p)} style={{ borderRadius: '15px', overflow: 'hidden', boxShadow: '0 6px 20px rgba(0,0,0,0.1)', background: '#fff', cursor: 'pointer', transition: 'transform 0.3s' }} onMouseEnter={e => (e.currentTarget.style.transform='translateY(-6px)')} onMouseLeave={e => (e.currentTarget.style.transform='translateY(0)')}>
                <div style={{ height: '180px', background: p.imageUrl ? `url(${p.imageUrl}) center/cover no-repeat` : '#ccc' }}></div>
                <div style={{ padding: '20px' }}>
                  <h3 style={{ margin: '0 0 12px 0' }}>{p.title}</h3>
                  <p style={{ margin: 0 }}>{p.description}</p>
                  <div style={{ marginTop: 10, display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {p.technologies.slice(0,4).map(t => <span key={t} style={{ background:'#f5f7ff', padding:'6px 8px', borderRadius:6, fontSize:12, color:'#333' }}>{t}</span>)}
                  </div>
                  <div style={{ marginTop:12, display:'flex', gap:10 }}>
                    {p.liveUrl && <a href={p.liveUrl} style={{ color:'#667eea', textDecoration:'none', fontWeight:700 }}>Live</a>}
                    {p.repoUrl && <a href={p.repoUrl} style={{ color:'#667eea', textDecoration:'none', fontWeight:700 }}>Source</a>}
                  </div>
                </div>
              </div>
            ))}
          </div> 
        </section>
       
        {sections.map((section, index) => (
          <section id={section.label} key={section.label} style={{ marginBottom: '80px', opacity: scrollY > index * 200 ? 1 : 0, transform: scrollY > index * 200 ? 'translateY(0)' : 'translateY(30px)', transition: 'all 0.8s ease-out' }}>
            <h2 style={{ fontSize: '32px', borderBottom: '3px solid #667eea', display: 'inline-block', paddingBottom: '6px', color: '#333', marginBottom: '16px' }}>{section.label}</h2>

            {section.label === 'Technical Skills' ? (
              <div style={{ marginTop: 16 }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: 18 }}>
                  {Object.entries(skillsData).map(([category, items]) => (
                    <div key={category} style={{ background: '#fff', padding: 16, borderRadius: 10, boxShadow: '0 6px 18px rgba(0,0,0,0.06)' }}>
                      <h3 style={{ margin: '0 0 8px', fontSize: 18 }}>{category}</h3>
                      <ul style={{ margin: 0, padding: 0, listStyle: 'none', color: '#555' }}>
                        {items.slice(0,3).map((it) => (
                          <li key={it} style={{ margin: '6px 0' }}>{it}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>
              </div>
            ) : (section.label === 'Projects' || section.label === 'Experience') ? (
              <ul style={{ marginTop: 12, color: '#555', fontSize: 18, lineHeight: 1.7 }}>
                {(Array.isArray(section.content) ? section.content : String(section.content).split(',').map(s => s.trim())).map(item => (
                  <li key={item} style={{ margin: '8px 0' }}>{item}</li>
                ))}
              </ul>
            ) : (section.label === 'About Me') ? (
              <p style={{ fontSize: '18px', color: '#555', lineHeight: 1.7 }}>{highlightTechnical(section.content)}</p>
            ) : (
              <p style={{ fontSize: '18px', color: '#555', lineHeight: 1.7 }}>{section.content}</p>
            )}

            {/* See more link */}
            <div style={{ textAlign: 'left', marginTop: 12 }}>
              {section.label === 'About Me' && <Link to="/about" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>See more</Link>}
              {section.label === 'Projects' && <Link to="/projects" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>See more</Link>}
              {section.label === 'Technical Skills' && <Link to="/skills" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>See more</Link>}
              {section.label === 'Experience' && <Link to="/about#Experience" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>See more</Link>}
              {/* {section.label === 'Contact' && <Link to="/contact" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 700 }}>See more</Link>} */}
            </div>
          </section>
        ))}


        

        {/* Social Links */}
        <SocialMedia links={socialLinks} />
      </main>

      {/* Modal */}
      {selectedProject && (
        <FeaturedProjectModal project={selectedProject} onClose={() => setSelectedProject(null)} />
      )}
    </div>
  );
}
export default MainPage;